import { render, staticRenderFns } from "./StudioMobileProfileMenu.vue?vue&type=template&id=5d3b590e&scoped=true&"
import script from "./StudioMobileProfileMenu.vue?vue&type=script&lang=ts&"
export * from "./StudioMobileProfileMenu.vue?vue&type=script&lang=ts&"
import style0 from "./StudioMobileProfileMenu.vue?vue&type=style&index=0&id=5d3b590e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3b590e",
  null
  
)

export default component.exports